import type { IHCPFlowKanbanCard as HCPFlowKanbanCard } from './hcp-flow-card.interface'

export enum HCPFlowEnum {
  AWAITING_ART = 'AWAITING_ART',
  SHEET = 'SHEET',
  PRODUCTION = 'PRODUCTION',
  MACHINE_PRODUCTION = 'MACHINE_PRODUCTION',
  LOGISTICS = 'LOGISTICS',
}

export interface IHCPFlowKanbanPayload {
  flow: HCPFlowEnum
  /** Client-only options; never sent as API query parameters. */
  forceRefresh?: boolean
  cacheScope?: string
  page?: number
  offset?: number
  searchBy?: string
  externalOsNumber?: string
  allArtsApproved?: boolean
  flowDeadlineStart?: string
  flowDeadlineEnd?: string
}

export interface IHCPFlowPositionPayload {
  flow: HCPFlowEnum
  statusSequence: number
  hcpFlowStatusId?: string
}

export interface IHCPFinishedPayload {
  hcpFinished: true
}

export interface IMoveHCPFlowCardPayload {
  flow: HCPFlowEnum
  statusSequence: number
  hcpFlowStatusId?: string
  productionBatchIds: Array<string | number>
  card?: HCPFlowKanbanCard
}

export interface IMoveHCPFlowCardsPayload {
  flow: HCPFlowEnum
  statusSequence: number
  hcpFlowStatusId?: string
  cards: HCPFlowKanbanCard[]
  concurrency?: number
}

export interface IHCPFlowSheetRule {
  familyValue?: string | null
  volumetryValue?: string | null
  masterCode?: string | null
}

export interface IHCPFlowStatus {
  id: string
  flow: string
  flowCode: number
  name: string
  sequence: number
  displayCode: string
  masterCode?: string | null
  isActive: boolean
  groupingMode?: 'ITEM' | 'HCP_PRE_SERVICE_ORDER'
  sheetRule?: IHCPFlowSheetRule | null
}

export interface IHCPFlowStatusInput {
  name: string
  sequence?: number
  masterCode?: string
  familyValue?: string
  volumetryValue?: string
  isActive?: boolean
  groupingMode?: 'ITEM' | 'HCP_PRE_SERVICE_ORDER'
}

export type {
  IHCPFlowKanbanCard,
  IHCPFlowHistory,
  IFlowManagementCardSelection,
} from './hcp-flow-card.interface'

export interface IHCPFlowKanbanColumn {
  statusId: string
  flow: string
  flowCode: number
  sequence: number
  displayCode: string
  name: string
  masterCode?: string | null
  isActive: boolean
  groupingMode?: 'ITEM' | 'HCP_PRE_SERVICE_ORDER'
  sheetRule?: IHCPFlowSheetRule | null
  page: number
  offset: number
  total: number
  hasNextPage: boolean
  cards: HCPFlowKanbanCard[]
}

export interface IHCPFlowKanbanResponse {
  fetchedAt?: number
  flow: string
  page: number
  offset: number
  columns: IHCPFlowKanbanColumn[]
  total: number
  hasNextPage: boolean
  eligibleToGeneratePreOsCount?: number
}
